import React from 'react';
import {Card, Col, Container, Row, Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faHeartPulse, faChartLine, faScroll, faPiggyBank, faArrowRight
} from '@fortawesome/free-solid-svg-icons';

const useCases = [
    {
        icon: faHeartPulse,
        accent: '#28a745',
        sector: 'HEALTHCARE',
        title: 'Clinical decision support',
        question: 'Drug interactions, contraindications, guideline adherence - cited recommendations in real time.'
    },
    {
        icon: faChartLine,
        accent: '#7030a0',
        sector: 'FINANCE',
        title: 'Financial decision support',
        question: 'Risk profiling, disclosure obligations, every recommendation traceable to policy.'
    },
    {
        icon: faScroll,
        accent: '#2f5597',
        sector: 'REGULATORY COMPLIANCE',
        title: 'Cross-document compliance',
        question: 'Override detection, transition tracking. FCA Handbook covered.'
    },
    {
        icon: faPiggyBank,
        accent: '#502070',
        sector: 'RISK',
        title: 'Risk Management',
        question: 'Capital rules, every decision matched to company rules and regulator guidance.'
    }
];

const UseCasesPreview = () => (
    <section className="use-cases-section">
        <Container>
            <div className="text-center mb-5">
                <div className="section-label">Use Cases</div>
                <h2>Where it works.</h2>
                <p className="section-intro">
                    Built  for industries where every decision needs to be defensible.
                </p>
            </div>

            <Row className="g-3">
                {useCases.map((u, i) => (
                    <Col key={i} xs={12} sm={6} lg={3}>
                        <Card className="use-case-card h-100 p-3">
                            <div className="use-case-accent" style={{background: u.accent}}/>
                            <Card.Body className="ps-3">
                                <FontAwesomeIcon icon={u.icon}
                                                 style={{color: u.accent, fontSize: '1.5rem', marginBottom: '0.5rem'}}/>
                                <div className="use-case-badge mt-2"
                                     style={{background: `${u.accent}15`, color: u.accent}}>
                                    {u.sector}
                                </div>
                                <h4 className="use-case-title">{u.title}</h4>
                                <p className="use-case-question">{u.question}</p>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <div className="text-center mt-4">
                <Button variant="outline-primary" href="/use-cases">
                    See all applications <FontAwesomeIcon icon={faArrowRight}/>
                </Button>
            </div>
        </Container>
    </section>
);

export default UseCasesPreview;